import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '../src/main-component/App/App';
import reportWebVitals from './reportWebVitals';
import GlobalAOSProvider from './GlobalAOSProvider/GlobalAOSProvider ';
// Critical CSS - load first
import 'bootstrap/dist/css/bootstrap.min.css';
import './css/style.css';
// Third-party library CSS
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// Icon fonts
import './css/fontawesome.css';
import './css/themify-icons.css';
// Non-critical CSS - load last
import './css/animate.min.css';
import './css/cursor.css';

const rootElement = document.getElementById('root');

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(
    rootElement,
    <GlobalAOSProvider>
      <App />
    </GlobalAOSProvider>
  );
} else {
  ReactDOM.createRoot(rootElement).render(
    <GlobalAOSProvider>
      <App />
    </GlobalAOSProvider>
  );
}

reportWebVitals();